import React, { Component } from "react";
import { connect } from "react-redux";
import { AddUserDialog } from "../dialogs/AddUserDialog";
import { addNewUser } from "../redux/actions/userActions";

class AddUser extends Component {
  state = {
    name: "",
    email: "",
    role: "",
    pass: "",
    passConfirm: "",
    passDoNotMatch: false,
    saveAvaliable: false,
    organizationKey: ""
  };

  componentDidMount() {
    const { currentUser } = this.props;
    const organizationKey = currentUser.organizationRef.id;
    this.setState({ organizationKey });
  }

  onSave = () => {
    const { addNewUser, onClose } = this.props;
    const { name, email, role, pass, organizationKey } = this.state;
    addNewUser({ name, email, role, password: pass, organizationKey });
    onClose();
  };

  onNameChange = name => this.setState({ name }, this.checkSaveAvaliable);

  onEmailChange = email => this.setState({ email }, this.checkSaveAvaliable);

  onRoleChange = role => this.setState({ role }, this.checkSaveAvaliable);

  onPassChange = pass => this.setState({ pass }, this.checkSaveAvaliable);

  onPassConfirmChange = passConfirm =>
    this.setState({ passConfirm }, this.checkSaveAvaliable);

  onOrganizationChange = organizationKey =>
    this.setState({ organizationKey }, this.checkSaveAvaliable);

  checkSaveAvaliable = () => {
    const {
      name,
      email,
      role,
      pass,
      passConfirm,
      organizationKey
    } = this.state;

    this.setState({
      passDoNotMatch: pass !== passConfirm && passConfirm !== ""
    });
    
    let saveAvaliable = true;
    if (
      name === "" ||
      email === "" ||
      role === "" ||
      pass === "" ||
      pass !== passConfirm ||
      organizationKey === ""
    )
      saveAvaliable = false;
    this.setState({ saveAvaliable });
  };

  render() {
    const { onClose } = this.props;
    const {
      name,
      email,
      role,
      pass,
      passConfirm,
      saveAvaliable,
      passDoNotMatch,
      organizationKey
    } = this.state;

    return (
      <AddUserDialog
        name={name}
        email={email}
        role={role}
        pass={pass}
        passConfirm={passConfirm}
        onCancel={onClose}
        onSave={this.onSave}
        saveAvaliable={saveAvaliable}
        onNameChange={this.onNameChange}
        onEmailChange={this.onEmailChange}
        onRoleChange={this.onRoleChange}
        onPassChange={this.onPassChange}
        onPassConfirmChange={this.onPassConfirmChange}
        passDoNotMatch={passDoNotMatch}
        organizationKey={organizationKey}
        onOrganizationChange={this.onOrganizationChange}
      />
    );
  }
}

const mapStateToProps = state => ({
  currentUser: state.user.user
});

const mapDispatchToProps = {
  addNewUser
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUser);
